import React from 'react';
import ClientCarousel from '../home/client-carousel';
import ScheduleCall from '../common/schedule-call';

const TechHeroFintechIndustry = () => {
    return (
        <section className="hero home-hero technology-herosection relative aiml-hero-section fintech-hero-section">
            <video playsInline autoPlay muted loop className="aimlvideo" height="100%" width="100%">
                <source src="media/video-fintech-hero.mp4" type="video/mp4" />
            </video>
            <div className="counter-overlay"></div>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="row grid lg:grid-cols-12 hero-row gap-6 relative z-[1] h-full">
                    <div className="lg:col-span-8 md:col-span-11 gap-4 grid">
                        <div className="inline-flex flex-col lg:items-start gap-4 hero-content justify-center h-full">
                            <p className="mb-0 fs-lg font-semibold text-white">FinTech Software Development Company</p>
                            <h1 className="mb-0 text-yellow">Build Next-Gen FinTech Solutions With Moweb Technologies</h1>
                            <p className="mb-0 font-semibold text-white">
                                Fintech is driving the future of finance—and we build the tech behind it.
                            </p>
                            <p className="mb-0 font-semibold text-white">
                                At Moweb Technologies, we develop secure, scalable solutions for banking, payments, lending, and
                                more.From AI-powered risk tools to seamless user experiences, we help fintechs launch fast and
                                grow smarter. As a trusted fintech app development company, we bring the speed of a startup with
                                the discipline of enterprise delivery.
                            </p>
                            <ScheduleCall />
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default TechHeroFintechIndustry;
